<template>
    <div>
        <div class="d-flex justify-content-start mb-3">
            <select id="institute" name="institute_relations" class="form-control ms-2" style="max-width:60%" v-model="selectedInsituteId" placeholder="Επιλέξτε Ιδρυμα ιστων" @change="onChangeInstitute">
                <option value="0" selected>Επιλέξτε Ιδρυμα ιστων</option>
                <option v-for="institute in institutions" :key="institute.id" :value="institute.id">{{ institute.title }}</option>
            </select>
            <button class="btn ms-2" @click="resetInstitute">
                <img src="../assets/images/asterisk16.png" alt="Citrine Logo" class="menu-img" style="width:1.1em; margin-right:10px"> Προβολή όλων...
            </button>
            <div v-if="selectedInstituteAfm" class="ms-3 mt-1">
                <p>ΑΦΜ επιλογής: <b>{{ selectedInstituteAfm }}</b></p>
            </div>
          
        </div>
        <!-- Tabs Navigation -->
        <ul class="nav nav-tabs" id="tabs" role="tablist">
            <li class="nav-item" v-for="tab in tabs" :key="tab.name" role="presentation">
                <button class="nav-link" :class="{ active: activeTab === tab.name }" @click="setActiveTab(tab.name)"
                    type="button" role="tab">
                    <img v-if="tab.label == 'Δηλωμένα μοσχεύματα'" src="../assets/images/implant_green16.png" alt="Citrine Logo" class="menu-img" style="width:1.1em; margin-right:10px">
                    <img v-if="tab.label == 'Μοσχεύματα προς εφαρμογή'" src="../assets/images/implant16.png" alt="Citrine Logo" class="menu-img" style="width:1.1em; margin-right:10px">
                    <img v-if="tab.label == 'Εφαρμοσμένα μοσχεύματα'" src="../assets/images/medical16.png" alt="Citrine Logo" class="menu-img" style="width:1.1em; margin-right:10px">
                    <img v-if="tab.label == 'Ληγμένα μοσχεύματα'" src="../assets/images/warning16.png" alt="Citrine Logo" class="menu-img" style="width:1.1em; margin-right:10px">
                    {{ tab.label }}
                </button>
            </li>
        </ul>
        <!-- Tabs Content -->
        <div class="tab-content mt-3">
            <div v-if="activeTab === 'installedimplants'" class="d-flex">
                
    <!-- Main Content Area -->
    <div class="content-area" :class="{ 'shrink': implantShown, 'expand': !implantShown }">
        <div>
            <!-- Search Controls -->
            <div class="d-flex">
                <label for="institute_relations ms-2 mt-3" style="margin-right:20px; margin-top:10px" class="form-label">
                    Αναζήτηση με:
                </label>
                <select name="institute_relations ms-2" style="max-width:30%" class="form-control" v-model="searchField" placeholder="Επιλέξτε κριτήριο" @change="handleRefresh">
                    <option value="" selected>Επιλέξτε...</option>
                    <option value="implant_name">Προίόν EUTC</option>
                    <option value="category">Κατηγορία</option>
                    <option value="provider_name">Προμηθευτής</option>
                    <option value="hospital_name">Μονάδα εφαρμογής</option>
                    <option value="sec">Κωδικός SEC</option>
                </select>
                <input type="text" class="form-control ms-2" style="max-width:30%" v-model="searchValue" placeholder="Κριτήριο..." />
                <button class="btn ms-2" @click="handleExport('installedImplants')">
                    <img src="../assets/images/excel16.png" alt="Excel" class="menu-img" style="width:1.1em; margin-right:10px">
                    MS-Excel
                </button>
            </div>

            <!-- Table -->
            <table class="table table-bordered table-hover table-striped">
                <tr style="border-bottom: 2px solid gray;"><td></td><td>Σύνολο: {{ totalCount }}</td><td></td><td></td><td></td><td></td><td></td></tr>

                <thead class="table-light">

                    <tr>
                        <th @click="sortTable('id')">
                            A/A
                            <span v-if="sortKey === 'id'">
                                <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                            </span>
                        </th>
                        <th @click="sortTable('implant_name')">
                            Προϊoν EUTC
                            <span v-if="sortKey === 'implant_name'">
                                <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                            </span>
                        </th>
                        <th @click="sortTable('category')">
                            Κατηγορια
                            <span v-if="sortKey === 'category'">
                                <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                            </span>
                        </th>
                        <th @click="sortTable('inst_insdate')">
                            Ημ/νια δηλωσης
                            <span v-if="sortKey === 'inst_insdate'">
                                <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                            </span>
                        </th>
                        <th @click="sortTable('inst_recvdate')">
                            Ημ/νια παραλαβης
                            <span v-if="sortKey === 'inst_recvdate'">
                                <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                            </span>
                        </th>
                        <th @click="sortTable('exp_date')">
                            Ημ/νια ληξης
                            <span v-if="sortKey === 'exp_date'">
                                <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                            </span>
                        </th>
                        <th @click="sortTable('sec')">
                            Κωδικος SEC
                            <span v-if="sortKey === 'sec'">
                                <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                            </span>
                        </th>
                        <th @click="sortTable('apply_date_ii')">
                            ΗΜ/ΝΙΑ ΔΙΑΝΟΜΗΣ
                            <span v-if="sortKey === 'apply_date_ii'">
                                <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                            </span>
                        </th>
                         <th @click="sortTable('inst_to_hospdate')">
                            ΗΜ/ΝΙΑ ΔΗΛΩΣΗΣ ΔΙΑΝΟΜΗΣ
                            <span v-if="sortKey === 'inst_to_hospdate'">
                                <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                            </span>
                        </th>
                        <!-- <th @click="sortTable('apply_status')">
                            Κατασταση
                            <span v-if="sortKey === 'apply_status'">
                                <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                            </span>
                        </th> -->
                        <th @click="sortTable('provider_name')">
                            Προμηθευτης
                            <span v-if="sortKey === 'provider_name'">
                                <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                            </span>
                        </th>
                        <th @click="sortTable('hospital_name')">
                            Μοναδα εφαρμογης
                            <span v-if="sortKey === 'hospital_name'">
                                <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                            </span>
                        </th>
                         <th @click="sortTable('institution_name')">
                            Ιδρυμα Ιστων
                            <span v-if="sortKey === 'institution_name'">
                                <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                            </span>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="implant in installedImplants" :key="implant.id" @click="showImplant(implant)"     
                    :class="{ active2: selectedRow?.id === implant.id }">
                        <td>{{ implant.id }}</td>
                        <td>{{ implant.implant_name }}</td>
                        <td>{{ implant.category }}</td>
                        <td>{{ formatLicenseExp(implant.inst_insdate) }}</td>
                        <td>{{ formatLicenseExp(implant.inst_recvdate) }}</td>
                        <td>{{ formatLicenseExp(implant.exp_date) }}</td>
                        <td :title="implant.sec">{{ limitSec(implant.sec) }}</td>
                        <td>{{ formatLicenseExp(implant.apply_date_ii) }}</td>
                        <!-- <td>{{ implant.katastasi }}</td> -->
                        <td>{{ formatLicenseExp(implant.inst_to_hospdate) }}</td>
                        <td>{{ implant.provider_name }}</td>
                        <td>{{ implant.hospital_name }}</td>
                        <td>{{ implant.institution_name }}</td>
                    </tr>
                </tbody>
            </table>
            <nav aria-label="Page navigation">
                            <ul class="pagination mt-4" v-if="paginationLinks && paginationLinks.length > 0">
                                <li class="page-item" v-for="(paginationLink, index) in paginationLinks"
                                    :key="index" :class="{ active: paginationLink.active }">
                                    <router-link
                                        :to="{ path: 'institutions', query: { page: getPageFromUrl(paginationLink.url) } }"
                                        v-if="paginationLink.url">
                                        <span class="page-link" v-html="paginationLink.label"></span>
                                    </router-link>
                                    <span class="page-link" v-else v-html="paginationLink.label"></span>
                                </li>
                            </ul>
                        </nav>
        </div>
    </div>

    <!-- Implant Details Panel -->
    <div class="implant_details" v-if="implantShown">
        <div class="d-flex align-items-center justify-content-between mb-4 mt-2 me-1">
            <label class="fw-bolder mb-0 me-2" style="font-size: large; white-space: nowrap;">
                Στοιχεία Μοσχεύματος
            </label>
            <div class="d-flex ms-auto">
                <button class="btn me-2" @click="download">
                    <img src="../assets/images/preview16.png" alt="Preview" class="menu-img" style="width: 1.1em;">
                    Αρχείο
                </button>
                <button class="btn" @click="closeDetails">
                    <img src="../assets/images/hide16.png" alt="Hide" class="menu-img" style="width: 1.1em;">
                </button>
            </div>
        </div>
        <h5 class="mb-4">{{ selectedImplant.implant_name }}</h5>
        <div class="implant-details-container">
            <div class="implant-detail shadow mb-2">
                <strong class="label-text">Α/Α</strong>
                <div class="value-text">{{ selectedImplant.id }}</div>
            </div>
            <div class="implant-detail shadow mb-2">
                <strong class="label-text">Κατηγορία</strong>
                <div class="value-text">{{ selectedImplant.category }}</div>
            </div>
          

            
            <div class="d-flex justify-content-between" style="width: calc(100% - 20px);">
                <div class="implant-detail shadow mb-2">
                <strong class="label-text">Ημ/νία Δήλωσης</strong>
                <div class="value-text">{{ formatLicenseExp(selectedImplant.inst_insdate) }}</div>
            </div>
            <div class="implant-detail shadow mb-2 ms-2">
                <strong class="label-text">Ημ/νία Εισαγωγής</strong>
                <div class="value-text">{{ formatLicenseExp(selectedImplant.inst_recvdate) }}</div>
            </div>

                    </div>

                    <div class="d-flex justify-content-between" style="width: calc(100% - 20px);">

            <div class="implant-detail shadow mb-2">
                <strong class="label-text">Ημ/νία Λήξης</strong>
                <div class="value-text">{{ formatLicenseExp(selectedImplant.exp_date) }}</div>
            </div>
            <div class="implant-detail shadow mb-2 ms-2">
                <strong class="label-text">Ημ/νία Δήλωσης Διανομής</strong>
                <div class="value-text">{{ formatLicenseExp(selectedImplant.inst_to_hospdate) }}</div>
            </div>
        </div>

            <div class="implant-detail shadow mb-2">
                <strong class="label-text">Κωδικός SEC</strong>
                <div class="value-text">{{ selectedImplant.sec }}</div>
            </div>
            <div class="implant-detail shadow mb-3">
            <strong class="label-text">Μονάδα εφαρμογής</strong>
            <div class="value-text">
                {{ selectedImplant.hospital_name ? selectedImplant.hospital_name : '-' }}
            </div>
        </div>

        <div class="implant-detail shadow mb-5">
                        <strong class="label-text">Προμηθευτης</strong>
                        <div class="value-text">{{ selectedImplant.provider_name }}</div>
                    </div>
                </div>
                <span class="smallTitle mt-5">*Τελευταία τροποποίηση: {{ selectedImplant.updated_at_formatted }}</span>
            </div>
        </div>


            <div v-if="activeTab === 'notusedimplants'" class="d-flex">
                <div class="content-area" :class="{ 'shrink': implantShown, 'expand': !implantShown }">
            <div>
                <!-- Search Controls -->
                <div class="d-flex">
                    <label for="institute_relations ms-2 mt-3" style="margin-right:20px; margin-top:10px" class="form-label">
                        Αναζήτηση με:
                    </label>
                    <select name="institute_relations ms-2" style="max-width:30%" class="form-control" v-model="searchField" placeholder="Επιλέξτε κριτήριο" @change="handleRefresh">
                        <option value="" selected>Επιλέξτε...</option>
                        <option value="implant_name">Προίόν EUTC</option>
                        <option value="category">Κατηγορία</option>
                        <option value="provider_name">Προμηθευτής</option>
                        <option value="hospital_name">Μονάδα εφαρμογής</option>
                        <option value="sec">Κωδικός SEC</option>
                    </select>
                    <input type="text" class="form-control ms-2" style="max-width:30%" v-model="searchValue" placeholder="Κριτήριο..." />
                    <button class="btn ms-2" @click="handleExport('notusedimplants')">
                        <img src="../assets/images/excel16.png" alt="Excel" class="menu-img" style="width:1.1em; margin-right:10px">
                        MS-Excel
                    </button>
                </div>
                        <table class="table table-bordered table-hover table-striped">
                            <tr style="border-bottom: 2px solid gray;"><td></td><td>Σύνολο: {{ totalCount }}</td><td></td><td></td><td></td><td></td><td></td></tr>

                            <thead class="table-light">
                                <tr>
                                    <th @click="sortTable('id')">
                                        A/A
                                        <span v-if="sortKey === 'id'">
                                            <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                        </span>
                                    </th>
                                    <th @click="sortTable('implant_name')">
                                        Προϊoν EUTC
                                        <span v-if="sortKey === 'implant_name'">
                                            <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                        </span>
                                    </th>
                                    <th @click="sortTable('category')">
                                        Κατηγορια
                                        <span v-if="sortKey === 'category'">
                                            <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                        </span>
                                    </th>
                                    <th @click="sortTable('inst_insdate')">
                                        Ημ/νια δηλωσης
                                        <span v-if="sortKey === 'inst_insdate'">
                                            <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                        </span>
                                    </th>
                                    <th @click="sortTable('inst_recvdate')">
                                        Ημ/νια εισαγωγης
                                        <span v-if="sortKey === 'inst_recvdate'">
                                            <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                        </span>
                                    </th>
                                    <th @click="sortTable('exp_date')">
                                        Ημ/νια ληξης
                                        <span v-if="sortKey === 'exp_date'">
                                            <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                        </span>
                                    </th>
                                    <th @click="sortTable('sec')">
                                        Κωδικoς SEC
                                        <span v-if="sortKey === 'sec'">
                                            <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                        </span>
                                    </th>
                                    <th @click="sortTable('provider_name')">
                                        Προμηθευτής
                                        <span v-if="sortKey === 'provider_name'">
                                            <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                        </span>
                                    </th>
                                    <th @click="sortTable('institution_name')">
                                        Ιδρυμα Ιστων
                                        <span v-if="sortKey === 'institution_name'">
                                            <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                        </span>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="implant in notUsedImplants" :key="implant.id" @click="showImplant(implant)":class="{ active2: selectedRow?.id === implant.id }">
                                    <td>{{ implant.id }}</td>
                                    <td>{{ implant.implant_name }}</td>
                                    <td>{{ implant.category }}</td>
                                    <td>{{ formatLicenseExp(implant.inst_insdate) }}</td>
                                    <td>{{ formatLicenseExp(implant.inst_recvdate) }}</td>
                                    <td>{{ formatLicenseExp(implant.exp_date) }}</td>
                                    <td :title="implant.sec">{{ limitSec(implant.sec) }}</td>
                                    <td>{{ implant.provider_name }}</td>
                                    <td>{{ implant.institution_name }}</td>
                                </tr>
                            </tbody>
                        </table>
                        <nav aria-label="Page navigation">
                            <ul class="pagination mt-4" v-if="paginationLinks && paginationLinks.length > 0">
                                <li class="page-item" v-for="(paginationLink, index) in paginationLinks"
                                    :key="index" :class="{ active: paginationLink.active }">
                                    <router-link
                                        :to="{ path: 'institutions', query: { page: getPageFromUrl(paginationLink.url) } }"
                                        v-if="paginationLink.url">
                                        <span class="page-link" v-html="paginationLink.label"></span>
                                    </router-link>
                                    <span class="page-link" v-else v-html="paginationLink.label"></span>
                                </li>
                            </ul>
                        </nav>
                    </div>
    </div>

    <!-- Implant Details Panel -->
    <div class="implant_details" v-if="implantShown">
        <div class="d-flex align-items-center justify-content-between mb-4 mt-2 me-1">
            <label class="fw-bolder mb-0 me-2" style="font-size: large; white-space: nowrap;">
                Στοιχεία Μοσχεύματος
            </label>
            <div class="d-flex ms-auto">
                <button class="btn me-2" @click="download">
                    <img src="../assets/images/preview16.png" alt="Preview" class="menu-img" style="width: 1.1em;">
                    Αρχείο
                </button>
                <button class="btn" @click="closeDetails">
                    <img src="../assets/images/hide16.png" alt="Hide" class="menu-img" style="width: 1.1em;">
                </button>
            </div>
        </div>
        <h5 class="mb-4">{{ selectedImplant.implant_name }}</h5>
        <div class="implant-details-container">
            <div class="implant-detail shadow mb-2">
                <strong class="label-text">Α/Α</strong>
                <div class="value-text">{{ selectedImplant.id }}</div>
            </div>
            <div class="implant-detail shadow mb-2">
                <strong class="label-text">Κατηγορία</strong>
                <div class="value-text">{{ selectedImplant.category }}</div>
            </div>
             
            <div class="d-flex justify-content-between" style="width: calc(100% - 20px);">
                <div class="implant-detail shadow mb-2">
                <strong class="label-text">Ημ/νία Δήλωσης</strong>
                <div class="value-text">{{ formatLicenseExp(selectedImplant.inst_insdate) }}</div>
            </div>
            <div class="implant-detail shadow mb-2 ms-2">
                <strong class="label-text">Ημ/νία Εισαγωγής</strong>
                <div class="value-text">{{ formatLicenseExp(selectedImplant.inst_recvdate) }}</div>
            </div>

                    </div>
            <div class="implant-detail shadow mb-2">
                <strong class="label-text">Ημ/νία Λήξης</strong>
                <div class="value-text">{{ formatLicenseExp(selectedImplant.exp_date) }}</div>
            </div>
           
            <div class="implant-detail shadow mb-2">
                <strong class="label-text">Κωδικός SEC</strong>
                <div class="value-text">{{ selectedImplant.sec }}</div>
            </div>
            
            <div class="implant-detail shadow mb-5">
                <strong class="label-text">Προμηθευτής</strong>
                <div class="value-text">{{ selectedImplant.provider_name }}</div>
            </div>
        </div>
        <span class="smallTitle mt-5">*Τελευταία τροποποίηση: {{ selectedImplant.updated_at_formatted }}</span>
    </div>
</div>


            <div v-if="activeTab === 'usedimplants'" class="d-flex">
                <!-- Main Content Area -->
    <div class="content-area" :class="{ 'shrink': implantShown, 'expand': !implantShown }">
        <div>
            <!-- Search Controls -->
            <div class="d-flex">
                <label for="institute_relations ms-2 mt-3" style="margin-right:20px; margin-top:10px" class="form-label">
                    Αναζήτηση με:
                </label>
                <select name="institute_relations ms-2" style="max-width:30%" class="form-control" v-model="searchField" placeholder="Επιλέξτε κριτήριο" @change="handleRefresh">
                    <option value="" selected>Επιλέξτε...</option>
                    <option value="implant_name">Προίόν EUTC</option>
                    <option value="category">Κατηγορία</option>
                    <option value="provider_name">Προμηθευτής</option>
                    <option value="hospital_name">Μονάδα εφαρμογής</option>
                    <option value="sec">Κωδικός SEC</option>
                </select>
                <input type="text" class="form-control ms-2" style="max-width:30%" v-model="searchValue" placeholder="Κριτήριο..." />
                <button class="btn ms-2" @click="handleExport('usedimplants')">
                    <img src="../assets/images/excel16.png" alt="Excel" class="menu-img" style="width:1.1em; margin-right:10px">
                    MS-Excel
                </button>
            </div>

                        <table class="table table-bordered table-hover table-striped">
                            <tr style="border-bottom: 2px solid gray;"><td></td><td>Σύνολο: {{ totalCount }}</td><td></td><td></td><td></td><td></td><td></td></tr>

                            <thead class="table-light">
                                <tr>
                                    <th @click="sortTable('id')">
                                        A/A
                                        <span v-if="sortKey === 'id'">
                                            <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                        </span>
                                    </th>
                                    <th @click="sortTable('implant_name')">
                                        Προϊόν EUTC
                                        <span v-if="sortKey === 'implant_name'">
                                            <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                        </span>
                                    </th>
                                    <th @click="sortTable('category')">
                                        Κατηγορια
                                        <span v-if="sortKey === 'category'">
                                            <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                        </span>
                                    </th>
                                    <th @click="sortTable('inst_insdate')">
                                        Ημ/νια δηλωσης
                                        <span v-if="sortKey === 'inst_insdate'">
                                            <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                        </span>
                                    </th>
                                    <th @click="sortTable('inst_recvdate')">
                                        Ημ/νια εισαγωγης
                                        <span v-if="sortKey === 'inst_recvdate'">
                                            <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                        </span>
                                    </th>
                                    <th @click="sortTable('exp_date')">
                                        Ημ/νια ληξης
                                        <span v-if="sortKey === 'exp_date'">
                                            <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                        </span>
                                    </th>
                                    <th @click="sortTable('sec')">
                                        Κωδικος SEC
                                        <span v-if="sortKey === 'sec'">
                                            <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                        </span>
                                    </th>
                                    <th @click="sortTable('apply_date_ii')">
                                        ΗΜ/ΝΙΑ ΔΙΑΝΟΜΗΣ
                                        <span v-if="sortKey === 'apply_date_ii'">
                                            <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                        </span>
                                    </th>

                                     <th @click="sortTable('inst_to_hospdate')">
                                        ΗΜ/ΝΙΑ ΔΗΛΩΣΗΣ ΔΙΑΝΟΜΗΣ
                                        <span v-if="sortKey === 'inst_to_hospdate'">
                                            <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                        </span>
                                    </th>
                                    <!-- <th @click="sortTable('apply_status')">
                                        Κατασταση
                                        <span v-if="sortKey === 'apply_status'">
                                            <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                        </span>
                                    </th> -->
                                    <th @click="sortTable('provider_name')">
                                        Προμηθευτης
                                        <span v-if="sortKey === 'provider_name'">
                                            <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                        </span>
                                    </th>
                                    <th @click="sortTable('hospital_name')">
                                        Μοναδα εφαρμογης
                                        <span v-if="sortKey === 'hospital_name'">
                                            <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                        </span>
                                    </th>
                                    <th @click="sortTable('institution_name')">
                                        Ιδρυμα Ιστων
                                        <span v-if="sortKey === 'institution_name'">
                                            <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                        </span>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="implant in usedImplants" :key="implant.id" @click="showImplant(implant)":class="{ active2: selectedRow?.id === implant.id }">
                                    <td>{{ implant.id }}</td>
                                    <td>{{ implant.implant_name }}</td>
                                    <td>{{ implant.category }}</td>
                                    <td>{{ formatLicenseExp(implant.inst_insdate) }}</td>
                                    <td>{{ formatLicenseExp(implant.inst_recvdate) }}</td>
                                    <td>{{ formatLicenseExp(implant.exp_date) }}</td>
                                    <td :title="implant.sec">{{ limitSec(implant.sec) }}</td>
                                    <td>{{ formatLicenseExp(implant.apply_date_ii) }}</td>
                                    <td>{{ formatLicenseExp(implant.inst_to_hospdate) }}</td>
                                    <!-- <td>{{ implant.katastasi }}</td> -->
                                    <td>{{ implant.provider_name }}</td>
                                    <td>{{ implant.hospital_name }}</td>
                                    <td>{{ implant.institution_name }}</td>
                                </tr>
                            </tbody>
                        </table>
                        <nav aria-label="Page navigation">
                            <ul class="pagination mt-4" v-if="paginationLinks && paginationLinks.length > 0">
                                <li class="page-item" v-for="(paginationLink, index) in paginationLinks"
                                    :key="index" :class="{ active: paginationLink.active }">
                                    <router-link
                                        :to="{ path: 'institutions', query: { page: getPageFromUrl(paginationLink.url) } }"
                                        v-if="paginationLink.url">
                                        <span class="page-link" v-html="paginationLink.label"></span>
                                    </router-link>
                                    <span class="page-link" v-else v-html="paginationLink.label"></span>
                                </li>
                            </ul>
                                       </nav>
        </div>
    </div>

    <!-- Implant Details Panel -->
    <div class="implant_details" v-if="implantShown">
        <div class="d-flex align-items-center justify-content-between mb-4 mt-2 me-1">
            <label class="fw-bolder mb-0 me-2" style="font-size: large; white-space: nowrap;">
                Στοιχεία Μοσχεύματος
            </label>
            <div class="d-flex ms-auto">
                <button class="btn me-2" @click="download">
                    <img src="../assets/images/preview16.png" alt="Preview" class="menu-img" style="width: 1.1em;">
                    Αρχείο
                </button>
                <button class="btn" @click="closeDetails">
                    <img src="../assets/images/hide16.png" alt="Hide" class="menu-img" style="width: 1.1em;">
                </button>
            </div>
        </div>
        <h5 class="mb-4">{{ selectedImplant.implant_name }}</h5>
        <div class="implant-details-container">
            <div class="implant-detail shadow mb-2">
                <strong class="label-text">Α/Α</strong>
                <div class="value-text">{{ selectedImplant.id }}</div>
            </div>
            <div class="implant-detail shadow mb-2">
                <strong class="label-text">Κατηγορία</strong>
                <div class="value-text">{{ selectedImplant.category }}</div>
            </div>
           
            <div class="d-flex justify-content-between" style="width: calc(100% - 20px);">
                <div class="implant-detail shadow mb-2">
                <strong class="label-text">Ημ/νία Δήλωσης</strong>
                <div class="value-text">{{ formatLicenseExp(selectedImplant.inst_insdate) }}</div>
            </div>
            <div class="implant-detail shadow mb-2 ms-2">
                <strong class="label-text">Ημ/νία Εισαγωγής</strong>
                <div class="value-text">{{ formatLicenseExp(selectedImplant.inst_recvdate) }}</div>
            </div>

                    </div>
                    <div class="d-flex justify-content-between" style="width: calc(100% - 20px);">

            <div class="implant-detail shadow mb-2">
                <strong class="label-text">Ημ/νία Λήξης</strong>
                <div class="value-text">{{ formatLicenseExp(selectedImplant.exp_date) }}</div>
            </div>
            <div class="implant-detail shadow mb-2 ms-2">
                <strong class="label-text">Ημ/νία Δήλωσης Διανομής</strong>
                <div class="value-text">{{ formatLicenseExp(selectedImplant.inst_to_hospdate) }}</div>
            </div>
            </div>
            <div class="implant-detail shadow mb-2">
                <strong class="label-text">Κωδικός SEC</strong>
                <div class="value-text">{{ selectedImplant.sec }}</div>
            </div>
            <div class="implant-detail shadow mb-3">
                <strong class="label-text">Μονάδα εφαρμογής</strong>
                <div class="value-text">{{ selectedImplant.hospital_name }}</div>
            </div>
            <div class="implant-detail shadow mb-5">
                <strong class="label-text">Προμηθευτής</strong>
                <div class="value-text">{{ selectedImplant.provider_name }}</div>
            </div>
        </div>
        <span class="smallTitle mt-5">*Τελευταία τροποποίηση: {{ selectedImplant.updated_at_formatted }}</span>
    </div>
</div>

            <div v-if="activeTab === 'expiredimplants'" class="d-flex">
                <!-- Main Content Area -->
    <div class="content-area" :class="{ 'shrink': implantShown, 'expand': !implantShown }">
        <div>
            <!-- Search Controls -->
            <div class="d-flex">
                <label for="institute_relations ms-2 mt-3" style="margin-right:20px; margin-top:10px" class="form-label">
                    Αναζήτηση με:
                </label>
                <select name="institute_relations ms-2" style="max-width:30%" class="form-control" v-model="searchField" placeholder="Επιλέξτε κριτήριο" @change="handleRefresh">
                    <option value="" selected>Επιλέξτε...</option>
                    <option value="implant_name">Προίόν EUTC</option>
                    <option value="category">Κατηγορία</option>
                    <option value="provider_name">Προμηθευτής</option>
                    <option value="hospital_name">Μονάδα εφαρμογής</option>
                    <option value="sec">Κωδικός SEC</option>
                </select>
                <input type="text" class="form-control ms-2" style="max-width:30%" v-model="searchValue" placeholder="Κριτήριο..." />
                <button class="btn ms-2" @click="handleExport('expiredimplants')">
                    <img src="../assets/images/excel16.png" alt="Excel" class="menu-img" style="width:1.1em; margin-right:10px">
                    MS-Excel
                </button>
            </div>

                        <table class="table table-bordered table-hover table-striped">
                            <tr style="border-bottom: 2px solid gray;"><td></td><td>Σύνολο: {{ totalCount }}</td><td></td><td></td><td></td><td></td><td></td></tr>

                            <thead class="table-light">
                                <tr>
                                    <th @click="sortTable('id')">
                                        A/A
                                        <span v-if="sortKey === 'id'">
                                            <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                        </span>
                                    </th>
                                    <th @click="sortTable('implant_name')">
                                        Προϊoν EUTC
                                        <span v-if="sortKey === 'implant_name'">
                                            <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                        </span>
                                    </th>
                                    <th @click="sortTable('category')">
                                        Κατηγορια
                                        <span v-if="sortKey === 'category'">
                                            <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                        </span>
                                    </th>
                                    <th @click="sortTable('inst_insdate')">
                                        Ημ/νια δηλωσης
                                        <span v-if="sortKey === 'inst_insdate'">
                                            <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                        </span>
                                    </th>
                                    <th @click="sortTable('inst_recvdate')">
                                        Ημ/νια εισαγωγης
                                        <span v-if="sortKey === 'inst_recvdate'">
                                            <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                        </span>
                                    </th>
                                    <th @click="sortTable('exp_date')">
                                        Ημ/νια ληξης
                                        <span v-if="sortKey === 'exp_date'">
                                            <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                        </span>
                                    </th>
                                    <th @click="sortTable('sec')">
                                        Κωδικος SEC
                                        <span v-if="sortKey === 'sec'">
                                            <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                        </span>
                                    </th>
                                    <!-- <th @click="sortTable('apply_date_ii')">
                                        Ημ/νία Δήλωσης Εφαρμογής
                                        <span v-if="sortKey === 'apply_date_ii'">
                                            <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                        </span>
                                    </th> -->
                                    <!-- <th @click="sortTable('apply_status')">
                                        Κατασταση
                                        <span v-if="sortKey === 'apply_status'">
                                            <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                        </span>
                                    </th> -->
                                    <th @click="sortTable('inst_to_hospdate')">
                                        ΗΜ/ΝΙΑ ΔΗΛΩΣΗΣ ΔΙΑΝΟΜΗΣ
                                        <span v-if="sortKey === 'inst_to_hospdate'">
                                            <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                        </span>
                                    </th>
                                    <th @click="sortTable('provider_name')">
                                        Προμηθευτης
                                        <span v-if="sortKey === 'provider_name'">
                                            <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                        </span>
                                    </th>
                                    <th @click="sortTable('hospital_name')">
                                        Μοναδα εφαρμογης
                                        <span v-if="sortKey === 'hospital_name'">
                                            <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                        </span>
                                    </th>
                                    <th @click="sortTable('institution_name')">
                                        Ιδρυμα Ιστων
                                        <span v-if="sortKey === 'institution_name'">
                                            <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                        </span>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="implant in expiredImplants" :key="implant.id" @click="showImplant(implant)":class="{ active2: selectedRow?.id === implant.id }">
                                    <td>{{ implant.id }}</td>
                                    <td>{{ implant.implant_name }}</td>
                                    <td>{{ implant.category }}</td>
                                    <td>{{ formatLicenseExp(implant.inst_insdate) }}</td>
                                    <td>{{ formatLicenseExp(implant.inst_recvdate) }}</td>
                                    <td>{{ formatLicenseExp(implant.exp_date) }}</td>
                                    <td :title="implant.sec">{{ limitSec(implant.sec) }}</td>
                                    <td>{{ formatLicenseExp(implant.inst_to_hospdate) }}</td>
                                    <!-- <td>{{ implant.katastasi }}</td> -->
                                    <td>{{ implant.provider_name }}</td>
                                    <td>{{ implant.hospital_name }}</td>
                                    <td>{{ implant.institution_name }}</td>
                                </tr>
                            </tbody>
                        </table>
                        <nav aria-label="Page navigation">
                            <ul class="pagination mt-4" v-if="paginationLinks && paginationLinks.length > 0">
                                <li class="page-item" v-for="(paginationLink, index) in paginationLinks"
                                    :key="index" :class="{ active: paginationLink.active }">
                                    <router-link
                                        :to="{ path: 'institutions', query: { page: getPageFromUrl(paginationLink.url) } }"
                                        v-if="paginationLink.url">
                                        <span class="page-link" v-html="paginationLink.label"></span>
                                    </router-link>
                                    <span class="page-link" v-else v-html="paginationLink.label"></span>
                                </li>
                            </ul>
                        </nav>
                    </div>
    </div>

    <!-- Implant Details Panel -->
    <div class="implant_details" v-if="implantShown">
        <div class="d-flex align-items-center justify-content-between mb-4 mt-2 me-1">
            <label class="fw-bolder mb-0 me-2 " style="font-size: large; white-space: nowrap;">
                Στοιχεία Μοσχεύματος
            </label>
            <div class="d-flex ms-auto">
                <button class="btn me-2" @click="download">
                    <img src="../assets/images/preview16.png" alt="Preview" class="menu-img" style="width: 1.1em;">
                    Αρχείο
                </button>
                <button class="btn" @click="closeDetails">
                    <img src="../assets/images/hide16.png" alt="Hide" class="menu-img" style="width: 1.1em;">
                </button>
            </div>
        </div>
        <h5 class="mb-4">{{ selectedImplant.implant_name }}</h5>
        <div class="implant-details-container">
            <div class="implant-detail shadow mb-2">
                <strong class="label-text">Α/Α</strong>
                <div class="value-text">{{ selectedImplant.id }}</div>
            </div>
            <div class="implant-detail shadow mb-2">
                <strong class="label-text">Κατηγορία</strong>
                <div class="value-text">{{ selectedImplant.category }}</div>
            </div>
            <div class="d-flex justify-content-between" style="width: calc(100% - 20px);">
                <div class="implant-detail shadow mb-2">
                    <strong class="label-text">Ημ/νία Δήλωσης</strong>
                    <div class="value-text">{{ formatLicenseExp(selectedImplant.inst_insdate) }}</div>
                </div>
                <div class="implant-detail shadow mb-2 ms-2">
                    <strong class="label-text">Ημ/νία Εισαγωγής</strong>
                    <div class="value-text">{{ formatLicenseExp(selectedImplant.inst_recvdate) }}</div>
                </div>
            </div>
            <div class="d-flex justify-content-between" style="width: calc(100% - 20px);">
                <div class="implant-detail shadow mb-2">
                    <strong class="label-text">Ημ/νία Λήξης</strong>
                    <div class="value-text">{{ formatLicenseExp(selectedImplant.exp_date) }}</div>
                </div>
                <div class="implant-detail shadow mb-2 ms-2">
                    <strong class="label-text">Ημ/νία Δήλωσης Διανομής</strong>
                    <div class="value-text">{{ formatLicenseExp(selectedImplant.inst_to_hospdate) }}</div>
                </div>
            </div>
           
            <div class="implant-detail shadow mb-2">
                <strong class="label-text">Κωδικός SEC</strong>
                <div class="value-text">{{ selectedImplant.sec }}</div>
            </div>
            
            <div class="implant-detail shadow mb-5">
                <strong class="label-text">Προμηθευτής</strong>
                <div class="value-text">{{ selectedImplant.provider_name }}</div>
            </div>
        </div>
        <span class="smallTitle mt-5">*Τελευταία τροποποίηση: {{ selectedImplant.updated_at_formatted }}</span>

    </div>
</div>
</div>

    </div>
</template>


<script>
import { getInstitutions, postInstitute, deleteInstitutionById, deleteRelationsForInstitute, getInstalled, getNotUsed, getUsed, getExpired, downloadExportInstall, downloadExportNotUsed, downloadExportUsed, downloadExportExpired, downloadFile } from "../services/institutions";
import { deleteHospitalById, getHospitals, postHospital } from "@/services/hospitals";
import { getGrafts, getGraftCategories, postCategory, postImplant, actImplant, deleteRelationsForImplant } from "@/services/grafts";
import { useToast } from "vue-toastification";
import * as XLSX from 'xlsx';
import { actProvider, deleteRelationsForProvider, getCountries, getSuppliers, postProvider } from "@/services/suppliers";

export default {
    data() {
        return {
            totalCount: 0,
            activeTab: "institutes",
            tabs: [
                { name: "installedimplants", label: "Δηλωμένα μοσχεύματα" },
                { name: "notusedimplants", label: "Μοσχεύματα προς εφαρμογή" },
                { name: "usedimplants", label: "Διανεμηθέντα μοσχεύματα" },
                { name: "expiredimplants", label: "Ληγμένα μοσχεύματα" },
            ],
            selectedInstituteAfm: null,
            searchField: "",
            searchValue: "",
            institutions: [],
            installedImplants: [],
            notUsedImplants: [],
            usedImplants: [],
            expiredImplants: [],
            paginationLinks: [],
            page: 1,
            selectedInsituteId: "0",
            selectedImplant: null,
            sortKey: "id",
            sortOrder: "desc",
            selectedField: "",
            implantShown: false,
            selectedRow: null, // To store the currently selected category

        };
    },
    methods: {
        onChangeInstitute() {
            let institute = null;
            for (let i = 0; i < this.institutions.length; i++) {
                if (this.institutions[i].id == $("#institute").val()) {
                    institute = this.institutions[i];
                }
            }
            if (institute) {
                this.selectedInstituteAfm = institute.afm;
            } else {
                this.selectedInstituteAfm = null;
            }
        },
        limitSec(sec) {
        if (sec && sec.length > 10) {
            return sec.substring(0, 10) + '...';
        }
        return sec;
    },
        download() {
            if (!this.selectedImplant.file_name) {
                useToast().error('Δεν υπάρχει αρχείο!');
            } else {
                downloadFile(this.selectedImplant.id, this.selectedImplant.file_name, this.selectedImplant.mime_type);
            }
        },
        closeDetails() {
            this.implantShown = false;
            this.selectedRow = null;
        },
        showImplant(implant) {
            this.selectedImplant = implant;
            this.implantShown = true;
            this.selectedRow = implant;

        },
        sortTable(column) {
            if (this.sortKey === column) {
                // Reverse order if the column is already sorted
                this.sortOrder = this.sortOrder === "asc" ? "desc" : "asc";
            } else {
                this.sortKey = column;
                this.sortOrder = "asc";
            }
            this.handleRefresh(this.activeTab);
        },
        getPageFromUrl(url) {
            if (!url) return null;
            const urlObj = new URL(url, window.location.origin);
            return urlObj.searchParams.get('page');
        },
        resetInstitute() {
            this.selectedInstituteAfm = null;
            this.selectedInsituteId = "0";
            this.page = 1; // Reset to page 1
            this.$router.push({
                path: this.$route.path,
                query: { ...this.$route.query, page: 1 }
            }).catch(err => {});
            this.handleRefresh('installedimplants');
        },
        // Existing methods remain unchanged...
        setActiveTab(tabName) {
            this.activeTab = tabName;
            this.page = 1; // Reset to page 1
            // Update the URL with page = 1
            this.$router.push({
                path: this.$route.path,
                query: { ...this.$route.query, page: 1 }
            });
            this.searchField = "";
            this.searchValue = "";
            // Trigger refresh for the new tab
            this.handleRefresh(tabName);
        },
        async handleRefresh(tabName) {
            let params = {
                    instid: this.selectedInsituteId,
                    sortBy: this.sortKey,
                    sortOrder: this.sortOrder,
                    page: this.page,
                    pageTitle : 'eomInstitutions'
                };
                if (this.searchField != "" && this.searchValue != "") {
                    params[this.searchField] = this.searchValue;
                }

            if (tabName === 'installedimplants') {
                const installedImplants = (await getInstalled(params)).data.data;
                this.installedImplants = installedImplants.results.data;
                this.paginationLinks = installedImplants.results.links;
                this.totalCount = installedImplants.count;
            } else if (tabName === 'notusedimplants') {
                const notUsedImplants = (await getNotUsed(params)).data.data;
                this.notUsedImplants = notUsedImplants.results.data;
                this.paginationLinks = notUsedImplants.results.links;
                this.totalCount = notUsedImplants.count;
            } else if (tabName === 'usedimplants') {
                const usedImplants = (await getUsed(params)).data.data;
                this.usedImplants = usedImplants.results.data;
                this.paginationLinks = usedImplants.results.links;
                this.totalCount = usedImplants.count;
            } else if (tabName === 'expiredimplants') {
                const expiredImplants = (await getExpired(params)).data.data;
                this.expiredImplants = expiredImplants.results.data;
                this.paginationLinks = expiredImplants.results.links;
                this.totalCount = expiredImplants.count;
            }
        },
        handleExport(tabName) {
            if (tabName == 'installedImplants') {
                downloadExportInstall();
            } else if (tabName == 'notusedimplants') {
                downloadExportNotUsed();
            } else if (tabName == 'usedimplants') {
                downloadExportUsed();
            } else if (tabName == 'expiredimplants') {
                downloadExportExpired();
    
            }
        },
        formatLicenseExp(date) {
            if (date == null) { return ''}
            return new Date(date).toLocaleDateString("el-GR", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
            });
        }
    },
    async mounted() {
        this.institutions = (await getInstitutions()).data.data;
        this.setActiveTab('installedimplants');
    },
    watch: {
        $route: {
            immediate: true,
            handler(newRoute) {
                const page = newRoute.query.page || 1; 
                this.page = page;
                this.handleRefresh(this.activeTab);
            }
        },
        selectedInsituteId: {
            immediate: true,
            handler() {
                this.page = 1; // Reset to page 1
                this.$router.push({
                    path: this.$route.path,
                    query: { ...this.$route.query, page: 1 }
                }).catch(err => {});
                this.handleRefresh(this.activeTab);
            }
        },
        searchField: {
            handler() {
                this.page = 1; // Reset to page 1
                this.$router.push({
                    path: this.$route.path,
                    query: { ...this.$route.query, page: 1 }
                }).catch(err => {});
                this.handleRefresh(this.activeTab);
            }
        },
        searchValue: {
            handler() {
                this.page = 1; // Reset to page 1
                this.$router.push({
                    path: this.$route.path,
                    query: { ...this.$route.query, page: 1 }
                }).catch(err => {});
                this.handleRefresh(this.activeTab);
            }
        }
    }
};
</script>

<style scoped>
.nav-tabs {
    border-bottom: 1px solid #ddd;
}

.nav-link {
    cursor: pointer;
}

.table {
    margin-top: 1rem;
}

.btn{
    background-color: #f6f6f6;
}

.btn:hover, .btn-md:hover{
    background-color: #ececec;
}
.btn-md{
    background-color: white;
    border:none;
}

.nav-link.active{
    border:none;
}

.modal-header{
   background-color: #6DB4E3;
}

.modal-title{
color:white;
}

.modal-content{
    border:none;
    margin-top:30%;
}
/* Add hover effect for rows */
.institution-row:hover .btn-md {
    background-color: #ececec;
}

.hospital-row:hover .btn-md {
    background-color: #ececec;
}

.btn2{
   background-color: #6DB4E3;
   color:white;
   border:none;
   border-radius:5px;
   padding:10px;
   margin-right:8px;
}

.implant_details2{
    transition: all 0.3s ease;
    min-width: 380px; /* Ensure the details panel doesn't shrink too much */

    padding-left:10px;
    border-left: 1px solid rgb(94, 94, 94);
    margin-left:10px;
}

.page-container {
    display: flex;
    width: 100%;
    height: 100%; /* Ensures the layout fits the screen height */
    overflow: hidden; /* Prevent overflow when zoomed */
}

.content-area {
    flex: 1; /* Default flex value */
    transition: all 0.3s ease-in-out;
    min-width: 0; /* Prevent the content from overflowing */
    padding-right: 10px; /* Add slight padding to avoid overlap */
}

.content-area.shrink {
    flex: 0.68; /* Slightly smaller to provide more space for details */
}

.implant_details {
    flex: 0.32; /* Adjusted to match shrink */
    overflow-y: auto;
    transition: all 0.3s ease-in-out;
    padding-left: 10px;
    border-left: 1px solid rgb(94, 94, 94);
    margin-left: 10px;
    min-width: 280px; /* Ensure the details panel doesn't shrink too much */
}

.implant-details-container {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    width: 100%;
}

.implant-detail {
    background: #fff;
    border-radius: 15px;
    box-shadow: 3px 3px 15px #c2c2c2;
    padding: 8px;
    width: calc(100% - 20px); /* Default to full width */
    padding-left: 10px;
    font-size:medium;
}

.label-text {
    font-size: 0.9rem;
    color: #6c757d; /* Muted text for the label */
    margin-bottom: 5px;
    display: block; /* Ensure label appears above */
}

.value-text {
    font-size: 1rem;
    font-weight: bold;
    color: #000;
}

.table {
    width: 100%; /* Ensure table stays within bounds */
    table-layout: fixed; /* Prevent columns from expanding uncontrollably */
    word-wrap: break-word; /* Handle long text gracefully */
}

th, td {
    text-align: left;
    vertical-align: middle;
    padding: 8px;
}



.content-area.w-100 {
    width: 100%;
    transition: width 0.3s ease-in-out;
}

.label-text, .value-text{
    font-size: small;
}

.active2 {
    background-color: #ffefbb; /* Light blue background */
    font-weight: bold; /* Make the text bold */
}


</style>